import { isUndNullEmp } from '../../helpers/main';

export class LoginRequest {
    constructor(
        _email = '',
        _password = '',
        _rememberMe = false,
    ) {
        this.email = _email;
        this.password = _password;
        this.rememberMe = _rememberMe;
    }

    static getClassName = () => {
        return 'Login - class';
    }

    static getClass = (obj = {}) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            return new LoginRequest(
                obj.email,
                obj.password,
                obj.rememberMe,
            );
        } else {
            return new LoginRequest();
        }
    }
}